export const setLogin = (bool) => ({
  type: "SET_LOGIN",
  data: bool,
});

export const setUserInfo = (bool) => ({
  type: "SET_USER_INFO",
  data: bool,
});

export const setCarouselDisplay = (bool) => ({
  type: "SET_CAROUSEL_STATUS",
  data: bool,
});

export const setFooterDisplay = (bool) => ({
  type: "SET_FOOTER_STATUS",
  data: bool,
});
